// src/app/services/usetiful.service.ts
import { Injectable } from '@angular/core';
import { loadUsetifulScript, setUsetifulTags } from 'usetiful-sdk';

@Injectable({ providedIn: 'root' })
export class UsetifulService {
  private loaded = false;

  /** 1) Carregar o script com seu token */
  init(token: string): void {
    if (this.loaded) return;
    loadUsetifulScript(token);
    this.loaded = true;
  }

  /** 2) Definir tags/identidade do usuário */
  setTags(tags: Record<string, any>): void {
    setUsetifulTags(tags);
  }

  /** Atalho para identificar usuário */
  // usetiful.service.ts
  identify(
    userId: string,
    opts?: { firstName?: string; lastName?: string; tags?: Record<string, any> }
  ): void {
    const tags: Record<string, any> = { userId };
    if (opts?.firstName) tags['firstName'] = opts.firstName;
    if (opts?.lastName) tags['lastName'] = opts.lastName;
    if (opts?.tags) Object.assign(tags, opts.tags);
    this.setTags(tags);
  }


  /** (Opcional) Iniciar tour manualmente */
  startTour(tourId: string | number): void {
    (window as any)?.USETIFUL?.tour?.start?.(tourId); // API não tipada
  }
}
